import { getSpacing } from "@faire/web/slate/spacing";
import styled, { css } from "styled-components";

import { ACCORDION_TRANSITION_TIMING } from "./utils";

export const AccordionText = styled.div<{
  $maxNumberOfLinesShownWhenCollapsed: number;
  $isAccordionOpen: boolean;
  $isFullTextVisible: boolean;
  $textExpandedHeight: number;
  $textCollapsedHeight: number;
  $isListOfItems?: boolean;
}>`
  text-align: start;
  word-break: break-word;
  white-space: pre-wrap;
  width: 100%;

  ${({ $isListOfItems }) =>
    $isListOfItems
      ? css`
          padding-left: ${getSpacing("1x")};
        `
      : ""}

  ${({ $isAccordionOpen, $textExpandedHeight, $textCollapsedHeight }) =>
    $isAccordionOpen
      ? css`
          max-height: ${$textExpandedHeight}px;
        `
      : css`
          max-height: ${$textCollapsedHeight}px;
        `}

  ${({ $isFullTextVisible, $maxNumberOfLinesShownWhenCollapsed }) =>
    !$isFullTextVisible
      ? css`
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: ${$maxNumberOfLinesShownWhenCollapsed};
        `
      : ""}

  text-overflow: ellipsis;
  overflow: hidden;

  transition-property: max-height;
  ${ACCORDION_TRANSITION_TIMING}
`;
